<template lang="pug">
    .mouseScroll(:class="{show: showMouse && !pageIsHidden}")
        .mouse(v-anchor="'.home .dates'" :data-anchor-offset="-fixedHeaderHeight - 20")
            img(src="@/assets/img/mouse.png")
            span
            span
</template>

<script>
    export default {
        name: "MouseScroll",
        data:()=>({
            showMouse: true,
        }),
        computed:{
            pageIsHidden(){
                return this.$store.state.pageIsHidden;
            }
        },
        methods:{
            handler(){
                if (window.pageYOffset === 0){
                    this.showMouse = true;
                }else{
                    this.showMouse = false;
                }
            }
        },
        mounted(){
            window.addEventListener('scroll', this.handler);
        },
        beforeDestroy(){
            window.removeEventListener('scroll', this.handler);
        },
        props: ['fixedHeaderHeight'],
    }
</script>

<style scoped lang="scss">
    .mouseScroll{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        height: 40vh;
        z-index: 10;
        background: linear-gradient(to top,#032d54 15%, transparent);
        pointer-events: none;
        transition: .5s;
        &:not(.show){
            opacity: 0;
            transform: translateY(50%);
            transition: opacity .5s, transform 0s .5s;
        }
    }
    .mouse{
        position: absolute;
        bottom: 3rem;
        left: 50%;
        transform: translateX(-50%);
        width: 2.3rem;
        pointer-events: all;
        cursor: pointer;
        img{
            width: 100%;
        }
        span{
            display: block;
            position: absolute;
            left: 50%;
            height: 1rem;
            transform: translateX(-50%);
            background: url(../../assets/img/arrow_white_2.png) no-repeat center center / contain;
            animation: arrowPuls 2s linear infinite;
            &:nth-of-type(1){
                top: calc(100% + -0.1rem);
                width: to_rem(18px);
                animation-delay: -0.5s;
            }
            &:nth-of-type(2){
                top: calc(100% + 0.5rem);
                width: 1.5rem;
            }
            @keyframes arrowPuls {
                from {
                    opacity: 0.25;
                }
                30%{
                    opacity: 1;
                }
                60%{
                    opacity: 0.25;
                }
                80%{
                    opacity: 0.25;
                }
                to{
                    opacity: 0.25;
                }
            }
        }
        @include mobile_or_P{
            bottom: 4rem;
        }
    }
</style>
